var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5C4.85 10.5 3.84792 10.1188 2.99375 9.35625C2.13958 8.59375 1.65 7.64167 1.525 6.5H2.55C2.66667 7.36667 3.05208 8.08333 3.70625 8.65C4.36042 9.21667 5.125 9.5 6 9.5C6.975 9.5 7.80208 9.16042 8.48125 8.48125C9.16042 7.80208 9.5 6.975 9.5 6C9.5 5.025 9.16042 4.19792 8.48125 3.51875C7.80208 2.83958 6.975 2.5 6 2.5C5.425 2.5 4.8875 2.63333 4.3875 2.9C3.8875 3.16667 3.46667 3.53333 3.125 4H4.5V5H1.5V2H2.5V3.175C2.925 2.64167 3.44375 2.22917 4.05625 1.9375C4.66875 1.64583 5.31667 1.5 6 1.5C6.625 1.5 7.21042 1.61875 7.75625 1.85625C8.30208 2.09375 8.77708 2.41458 9.18125 2.81875C9.58542 3.22292 9.90625 3.69792 10.1438 4.24375C10.3813 4.78958 10.5 5.375 10.5 6C10.5 6.625 10.3813 7.21042 10.1438 7.75625C9.90625 8.30208 9.58542 8.77708 9.18125 9.18125C8.77708 9.58542 8.30208 9.90625 7.75625 10.1438C7.21042 10.3813 6.625 10.5 6 10.5ZM7.4 8.1L5.5 6.2V3.5H6.5V5.8L8.1 7.4L7.4 8.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory24Px);
export default __webpack_public_path__ + "static/media/history_24px.6c51704e83f00ce1f0628672a0104a6c.svg";
export { ForwardRef as ReactComponent };